import { useTranslation } from 'react-i18next';

const Separator = () => {
  const { t } = useTranslation();
  return (
    <div className="option-separator">
      <div className="option-separator__line" />
      <span className="option-separator__separator">{t('PAGES.LOGIN.ACTIONS.SEPARATOR')}</span>
      <div className="option-separator__line" />
    </div>
  );
};

export default Separator;
